import { useSyncExternalStore } from 'react';

/** Subscribes to a CSS media query. Defaults to `fallback` where matchMedia is missing (SSR, odd test runtimes). */
export function useMediaQuery(query: string, fallback = false): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () =>
      typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia(query).matches
        : fallback,
    () => fallback,
  );
}

/** Tailwind `lg`: the sidebar is docked at this width and above, a drawer below. */
export const DESKTOP_QUERY = '(min-width: 1024px)';
